import { TFormalOffer } from './formalOffers.types';

/**
 * Checks if an offer is an RBL(merchant_cash_advance) offer
 *
 * @param formalOffer A formal offer object.
 * @returns `true` if the formal offer product_type is 'merchant_cash_advance'.
 */
export const getIsRBLOffer = (formal_offer: TFormalOffer): boolean => {
    return formal_offer.product_type === 'merchant_cash_advance';
};
